// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__IBAJM","link":"NotFound_link__D0B5M"};